var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('div',[_c('AppNavigationComponent',{attrs:{"drawer":_vm.drawer},on:{"input":function($event){_vm.drawer = $event}}}),_c('AppBarComponent',{on:{"drawer-changed":function($event){_vm.drawer = $event}}}),_c('v-main',{staticClass:"main-content"},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }